module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/deepcopy/index.js
// module id = 7
// module chunks = 0